import styled, { css } from 'styled-components'
import { TypographyComponent } from '../Typography'

export const HelperText = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      color: ${theme.colors.error.main};
    }
  `
)
